import { z } from "zod";

const ChangeCommentSchema = z.object({
    public_note: z.nullable(z.string()).optional(),
    private_note: z.nullable(z.string()).optional(),
});

export { ChangeCommentSchema };
export type ChangeCommentForm = z.infer<typeof ChangeCommentSchema>;